import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS } from '../types/auth';
import { VERIFY_OTP_INVESTOR_SUCCESS } from '../types/onBoarding';

export const SET_PPM_VIEWED = 'SET_PPM_VIEWED';

const initState: Partial<{
  token: string | null;
  ppmViewed: boolean;
}> = {
  token: null,
  ppmViewed: false,
};

export const setPpmViewed = (value: boolean) => ({
  type: SET_PPM_VIEWED,
  payload: value,
});

function investorReducer(
  state = initState,
  action: AnyAction
): Partial<{
  token: string | null;
  ppmViewed: boolean;
}> {
  switch (action.type) {
    case VERIFY_OTP_INVESTOR_SUCCESS: {
      return {
        ...state,
        ...action.body,
      };
    }
    case SET_PPM_VIEWED: {
      return {
        ...state,
        ppmViewed: action.payload,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    default:
      return state;
  }
}

export default investorReducer;
